import { useState, useCallback } from 'react';

/**
 * Nice way of handling multiple input states with hooks
 *
 * @param {Object} defaultInputState
 */
const useHandleInputs = (defaultInputState = {}) => {

	const [inputs, setInputs] = useState(defaultInputState);

	// Useful way of having all inputs use the same onChange method
	// ensure the input has a name that matches one in the defaultInputState
	const onChange = e => {
		const { name, value } = e.target;
		setInputs({
			...inputs,
			[name]: value,
		});
	};

	const updateInputs = useCallback(newInputState => setInputs(prev => ({ ...prev, ...newInputState })), []);

	return [inputs, onChange, updateInputs];
};

export default useHandleInputs;
